import classNames from "classnames";
import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { CSS_CLASSES } from "./ripple-css-classes";

export interface RippleProps {
  className?: string;
}

export const Ripple = ({ className }: RippleProps) => {
  const ref = useRef<HTMLDivElement>();
  const [style, setStyle] = useState<CSSProperties>({});

  useEffect(() => {
    const parentEl = ref.current.parentElement;
    const size = Math.max(parentEl.clientWidth, parentEl.clientHeight);
    setStyle({ width: size, height: size });
  }, [ref]);

  return <div role="presentation" ref={ref} className={classNames(CSS_CLASSES.RIPPLE_ROOT, className)} style={style} />;
};
